export default __webpack_public_path__ + "static/media/03e272c6641bff844f4f15afdcfa81931578323834593.b1c31eb8.webp";